import { createFileRoute, redirect } from "@tanstack/react-router";

import { LoginSsoPage } from "@onesolution/pages";
import { getUserFromSession } from "@onesolution/utils";

export const Route = createFileRoute("/(auth)/login-sso")({
	beforeLoad: async () => {
		const user = await getUserFromSession();

		// biome-ignore lint/complexity/useOptionalChain: false positive
		if (user && user?.isAuthenticated) {
			throw redirect({ to: "/", replace: true });
		}
	},
	component: LoginSsoPage,
});
